export default __webpack_public_path__ + "a152ac31c6fbf295bd06a94832a0a534.svg";